import store from '@/store';
import {get as getCookie, set as setCookie} from '@/lib/cookie';
import {APP_ID} from '@/common/config';

import {
    // checkLoginStatus,
    getRedirectUrl,
    checkUserPermission,
    checkLimitRole,
    getUseridFromUrl
} from '@/common/util';

const checkRoutePermission = to => {
    const bizHags = store.state.app.userInfo.bizHags;
    return (!to.meta?.authorizedRole || checkUserPermission(to.meta.authorizedRole))
        && (!to.meta?.limitRole || checkLimitRole(bizHags, to.meta.limitRole));
};

export const checkRouteLogin = (to, from, next) => {
    let toName = to.name || '';
    let hasLogin = !!(store.state?.app?.userInfo?.accountInfo?.userName);
    const CPID = getCookie(`CPID_${APP_ID}`) || '';
    const CPTK = getCookie(`CPTK_${APP_ID}`) || '';
    let userId = to.params?.userid || from.params?.userid || getUseridFromUrl();
    // cookie失效、登录其他账户时，会被拼入旧cookie里的ID，不能直接使用。如果已经登录的状态下，cookie会被重写，此时才能用

    // 如果跳到无效路由，则重定向到404，不拼id，无需登录
    if (to.matched == null || to.matched.length < 1) {
        // 无效路由，尝试带上uid后继续跳转、到可匹配uid的路由
        if (!userId && CPID) {
            userId = CPID;
        }
        if (userId && !to.params?.userid) {
            let pathPrefix = `/user/${userId}`;
            if (to.path.indexOf(pathPrefix) !== 0) {
                if (to.path.indexOf('/') !== 0) {
                    pathPrefix += '/';
                }
                if (to.path !== '/') {
                    next({
                        path: pathPrefix + to.path
                    });
                }
                return false;
            }
        }
        next({path: '/Exception/404'});
        return false;
    }
    // 已有登录信息，取出uid;
    if (hasLogin && !userId && CPID) {
        userId = CPID;
    }
    // 未登录，但当前页面要求必须登录的：拦截路由跳转动作 ，先加载登录信息，加载成功则正常跳转；失败则跳到登录页
    else if (!hasLogin && !to.meta.allowNotLogin) {
        const hairuo = {
            userid: userId || CPID,
            optid: CPID,
            token: CPTK,
            allowNotLogin: to.meta.allowNotLogin,
            toPath: to.path
        };
        store.dispatch('getUserInfo', hairuo).then(data => {
            if (!checkRoutePermission(to)) {
                if (to.meta?.show404) {
                    next({path: '/Exception/404'});
                }
                else {
                    next({name: '403', params: {userid: hairuo.userid}});
                }
                return false;
            }
            // 商业化229,外部用户不可查看的页面(生成式首页、创意资产)跳转404
            if (to.meta?.forbidOuterUser && store.state.app.userInfo.isOuterUser) {
                next({path: '/Exception/404'});
                return false;
            }
            // 登录成功就可以按原目的跳转
            if (data?.accountInfo && hairuo.userid) {
                // 防止未成功带参数，需要进行追加
                next({
                    ...to,
                    params: {
                        ...to.params,
                        userid: hairuo.userid
                    }
                });
            }
            else if (data.message === '无操作权限') {
                next({
                    name: 'noAgentAuth'
                });
            }
            else {
                // 获取登录信息失败则跳到未登录的页面
                // ToDo：如果错误的uid，获取信息失败；获取对uid没有代操作权限，应该进行特殊提示
                // next({
                //     path: '/login'
                // });
                console.log('before each', data);
                // 检测是不是重复定向，避免死循环，如果有重定向记录，则只回到login
                // 触发登录的时候，才写入cookie
                const {userid, optid} = hairuo;
                const lastKey = `aigc-reload-${userid}-${optid}`;
                const nowTime = new Date().getTime();
                // 30s
                const timeSpan = 15000;
                if (userid && optid) {
                    // 取出cookie
                    const lastReloadTime = getCookie(lastKey);
                    if (lastReloadTime && (nowTime - lastReloadTime) < timeSpan) {
                        // 如果距上次重加载不超过30s，则不再执行动作，避免重复循环
                        console.log('前往登录页面');
                        next({
                            path: '/login'
                        });
                        return;
                    }
                }
                setCookie(lastKey, nowTime, {
                    expires: new Date(nowTime + timeSpan),
                    path: '/',
                    domain: window.location.hostname,
                    secure: false
                });
                window.location.href = getRedirectUrl(to.fullPath);
            }
        });
        return false;
    }
    // 共拓计划官网单独的页面title
    const coExtensionPages = ['coExtensionHome', 'coExtensionMarket', 'coExtensionMarketDetail'];
    if (coExtensionPages.includes(toName)) {
        window.document.title = '共拓计划';
    }
    if (!to.meta.allowNotLogin && !hasLogin) {
        next({
            path: '/login'
        });
        return false;
    }
    // 如果登录了、路由里没有userid，则需要把userid拼到路由里
    if (hasLogin && !to.params?.userid && !to.meta.allowNotLogin) {
        let pathPrefix = `/user/${userId}`;
        if (userId && to.path.indexOf(pathPrefix) !== 0) {
            if (to.path.indexOf('/') !== 0) {
                pathPrefix += '/';
            }
            // 如果path有值，则拼接前缀；如果path无值，则push路由名+参数，防止重复留在首页
            if (to.path === '/') {
                next({
                    name: to.name,
                    params: {
                        userid: userId
                    }
                });
            }
            else {
                next({
                    path: pathPrefix + to.path
                });
            }
            return false;
        }
    }
    // 如果跳到无效路由，则重定向到404
    if (to.matched == null || to.matched.length < 1) {
        // 无效路由，尝试带上uid后继续跳转、到可匹配uid的路由
        if (userId && !to.params?.userid) {
            next({
                ...to,
                params: {
                    ...to.params,
                    userid: userId
                }
            });
            return false;
        }
        next({name: '404', params: {userid: userId}});
        return false;
    }
    const hairuo = {
        userid: userId,
        optid: CPID,
        token: CPTK,
        allowNotLogin: to.meta.allowNotLogin,
        toPath: to.path
    };
    // 如果有账户ID，且不是登录的本人，则先调用接口
    if ((from.matched == null || to.matched[0] !== from.matched[0])
        && !to.meta.allowNotLogin
    ) {
        // 如果切换模块，账户ID不变的话，只重新查询点券即可；
        store.dispatch('getPriceInfo', hairuo);
    }
    // 当前后账户ID不同的时候，再重新拉取账户信息。否则每次切换模块都要loading，太慢
    if (from.params?.userid == null || from.params?.userid !== to.params?.userid) {
        // 先加载，完成后判断是否有权限
        store.dispatch('getUserInfo', hairuo).then(data => {
            if (!checkRoutePermission(to)) {
                if (to.meta?.show404) {
                    next({path: '/Exception/404'});
                }
                else {
                    next({name: '403', params: {userid: hairuo.userid}});
                }
                return false;
            }
            // 商业化229,外部用户不可查看的页面(生成式首页、创意资产)跳转404
            if (to.meta?.forbidOuterUser && store.state.app.userInfo.isOuterUser) {
                next({path: '/Exception/404'});
                return false;
            }
            // 如果是首页，由于默认不自动拼cookie里的uid了，
            // 则登录成功后，把首页的还是要拼入，如果代理商代操作要修改uid的话能够操作
            const newCPID = getCookie(`CPID_${APP_ID}`) || '';

            if (data.message === '无操作权限') {
                next({
                    name: 'noAgentAuth'
                });
            }
            // 未登录成功则不继续了
            if (!store.state?.app?.userInfo?.accountInfo?.userName) {
                return;
            }
            if (!userId && newCPID) {
                userId = newCPID;
            }
            // 无需登录的页面不要拼接uid。但是首页希望拼上
            if (!to.params?.userid && userId
                && (to.name === 'home' || to.name === 'homeV2' || !to.meta.allowNotLogin)
            ) {
                let pathPrefix = `/user/${userId}`;
                if (to.path.indexOf('/') !== 0) {
                    pathPrefix += '/';
                }
                next({
                    path: pathPrefix + to.path
                });
            }
        });
        // 正常执行跳转，loading在APP.vue里控制
        next();
        return false;
    }

    if (
        !checkRoutePermission(to)
        || (to.meta?.forbidOuterUser && store.state.app.userInfo.isOuterUser)
    ) {
        next({name: '403', params: {userid: userId}});
        return false;
    }
    next();
};
